import axios from "axios"

const route = '/physical_progress';

export default {
  namespaced: true,

  state: () => ({
    dialogNewComposition: false
  }),
  getters: {

  },
  mutations: {

  },
  actions: {

    index(context, data) {
      let pagination = `?page=${data.page}&items_per_page=${data.ItemsPerPage || 10}&search=${data.search}`
      return axios.get(`${route}/metering_mop` + pagination)
    },
    // index() {
    //   // let pagination = `?page=${data.page}&items_per_page=${data.ItemsPerPage || 10}&search=${data.search}`
    //   return axios.get(`${route}/metering_mop`)
    // },


    update(context, data) {
      return axios.put(route + '/metering_mop/' + data.metering_mop_id, data)
    },

    approvedServices() {
      return axios.post(route + '/metering_mop/approve')
    },


    newMeteringMop() {
      return axios.post(route + '/metering_mop')
    },

    //historico das medicoes
    getHistoricMetering() {
      return axios.get(route + '/metering_mop/historic')
    },

    //carrega uma medicao mop histrico
    getMeteringMop(context, metering_mop_id) {
      return axios.get(route + '/metering_mop/' + metering_mop_id)
    },

    //exportar pdf
    getExportPdf(context, metering_mop_id) {
      return axios.get(route + '/metering_mop/export_pdf/' + metering_mop_id, { responseType: 'blob' })
    },

    //carrega os serviços
    getServices(context, searchService) {
      return axios.get('/helper/get_services?search=' + searchService)
    },


    getStagesPerCostCurrent() {
      return axios.get('helper/get_stages_per_cost_current');
    },

    //funcoes
    getEmployeeRole() {
      return axios.get(route + `/metering_mop/get_employee_roles/all`);
    },

    syncEmployeeRole() {
      return axios.get(route + `/metering_mop/sync_employee_roles/chess_gestao`);
    },
    //CRIAR EQUIPE
    /**
     * lista de equipes
     */
    getTeams(context, metering_mop_id) {
      return axios.get(route + `/metering_mop/all/team/${metering_mop_id}`);
    },
    /**
     * sincroniza os funcionarios com o chessgestao
     */
    syncEmployee() {
      return axios.get(route + `/metering_mop/sync_employees/chess_gestao`);
    },
    /**
     * Carrega os funcionarios
     */
    loadEmployees() {
      return axios.get(route + `/metering_mop/employee/all`);
    },
    /**
     * salva uma nova equipe
     */
    storeTeam(context, data) {
      return axios.post(route + `/metering_mop/team`, data);
    },
    //apaga equipe
    destroyTeam(context, team) {
        return axios.delete(route + `/metering_mop/team/` + team.id);
    },
    /**
     * atualiza uma equipe
     */
    updateTeam(context, data) {
      return axios.put(route + `/metering_mop/team/` + data.id, data);
    },

    addEmployeeRoles(context, data) {
      return axios.post(route + `/metering_mop/add_employee_roles`, data);
    },

    deleteEmployeeRole(context, metering_mop_employee_role_id) {
      return axios.delete(route + `/metering_mop/delete_metering_mop_employee_role/` + metering_mop_employee_role_id)
    },
    /**
     * Adiciona uma equipe à medição MOP.
     */
    addTeamMeteringMop(context, data) {
      return axios.post(route + `/metering_mop/add_team`, data);
    },
    /**
     * Remove uma equipe da medição MOP.
     */
    removeTeamMeteringMop(context, data) {
      return axios.post(route + `/metering_mop/remove_team`, data);
    },
    /**
     * retorna a equipe da medição MOP.
     */
    // getTeamMeteringMop(context, {metering_mop_id,composition_id}) {
    //   return axios.get(route + `/metering_mop/team/${metering_mop_id}/${composition_id}`);
    // },
    /**
     * save serviço
     */
    // saveServiceEmployee(context, data) {
    //   return axios.post(route + `/metering_mop/team/save_employee_composition`, data)
    // },
    //carrega a equipe da medição MOP.
    getMeteringMopTeam(context, { metering_mop_id, team_id }) {
      return axios.get(route + `/metering_mop/team/${metering_mop_id}/${team_id}`);
    },

    //salva a equipe da medição MOP.
    saveMeteringMopTeam(context, data) {
      return axios.post(route + `/metering_mop/team/save`, data);
    },

    //historico da equipe
    getHistoricTeam(context, team_id) {
      return axios.get(route + `/metering_mop/team_historic/${team_id}`);
    },

    /**
     * aprovar equipe
    */
    approveTeam(context,data){
        return axios.post(route + `/metering_mop/approve_team`,data);
    },
    /**
     * aprovar equipe
    */
    notApproveTeam(context,data){
        return axios.post(route + `/metering_mop/not_approve_team`,data);
    }

  }
}


